import React, { Fragment, useEffect, useState } from 'react'
import Select from 'react-select'

import { MONTHS } from 'lib/utils'

const SelectDate = props => {
  const [dateParts, setDateParts] = useState({ month: null, day: null, year: null })

  useEffect(() => {
    if (props.defaultDate) {
      const dateParts = props.defaultDate.split('-')
      setDateParts({ month: dateParts[1], day: dateParts[2], year: dateParts[0] }) 
    } else {
      setDateParts({ month: null, day: null, year: null }) 
    }
  }, [props.defaultDate])

  const onChange = (key, data) => {
    const newDateParts = { ...dateParts, [key]: data.value }
    setDateParts({ ...newDateParts })
    if (props.onChange) props.onChange({ ...newDateParts })
    if (newDateParts.month && newDateParts.day && newDateParts.year) {
      props.onFinal(newDateParts)
    }
  }
  
  const _getMonth = () => {
    const options = MONTHS.map(month => {
      return { value: month.value, label: month.label }
    })
    let val = null
    if (dateParts.month && dateParts.month !== '') {
      val = options.find(opt => opt.value === dateParts.month)
    }
    return (
      <Select
        id="month"
        value={val}
        onChange={val => onChange('month', val)}
        options={options}
        placeholder="Month"
        autoFocus 
        styles={{
          menu: provided => ({ ...provided, zIndex: 9999 })
        }}
      />
    )
  }

  const _getDay = () => {
    const options = []
    let i
    for(i = 1; i <= 31; i++) {
      options.push({ value: String(i), label: String(i) })
    }
    let val = null
    if (dateParts.day && dateParts.day !== '') {
      val = options.find(opt => opt.value === dateParts.day)
    }
    return (
      <Select
        id="day"
        value={val}
        onChange={val => onChange('day', val)}
        options={options}
        placeholder="Day"
        styles={{
          menu: provided => ({ ...provided, zIndex: 9999 })
        }}
      />
    )
  }

  const _getYear = () => {
    let currentYear = new Date().getFullYear()
    if (props.isDob) {
      currentYear = (new Date().getFullYear() - 12)
    }
    const options = []
    let i
    for(i = currentYear; i >= (currentYear - 100); i--) {
      options.push({ value: String(i), label: String(i) })
    }
    let val = null
    if (dateParts.year && dateParts.year !== '') {
      val = options.find(opt => opt.value === dateParts.year)
    }
    return (
      <Select
        id="year"
        value={val}
        onChange={val => onChange('year', val)}
        options={options}
        placeholder="Year"
        styles={{
          menu: provided => ({ ...provided, zIndex: 9999 })
        }}
      />
    )
  }

  return (
    <Fragment>
      {_getMonth()}
      {_getDay()}
      {_getYear()}
    </Fragment>
  )
}

export default SelectDate